import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import PropTypes from 'prop-types';
import './saveState.css';
import { setIsActive } from './../../../../redux/actions/entities/pages';
import { saveState } from './../../../../redux/actions/entities/io';
import { isOrder } from './../../../../redux/actions/ui/isOrder';
import {
  getMinimumSheets,
  showAlertModal,
  hasEmptyPlaceholder,
  configExist,
  GetActivePage,
  hasEmptyPlaceholderInPages,
} from './../../../../redux/helpers/';
import {
  getParams,
  getDomain,
} from './../../../../redux/helpers/getParams';


class SaveState extends Component {
  constructor(...args) {
    super(...args);
    this.saveState = this.saveState.bind(this);
    this.orderNow = this.orderNow.bind(this);
    this.folderId = 0;
    this.bookId = getParams('calendarId');
    this.referer = getDomain();
    this.ORDER_NOW_URL = '';
    const referer = getDomain();
    this.getStateURL = configExist('legacyContent', referer);
    // api/calendar/10971/setProductStatus

    this.ORDER_URL = `${this.getStateURL}/api/calendar/${this.bookId}/setProductStatus`;
    this.CART_URL = `${this.getStateURL}/cart`;
    this.DELETE_TEXT_URL = `${this.getStateURL}/${this.bookId}/textimageclear`;
    this.continue = false;
    this.loaded = 'loaded';
    this.order = false;
  }

  componentDidUpdate(prevProps) {
    const { folderId } = this.props.state.bookProperties;
    const { folderId: prevFolderId } = prevProps.state.bookProperties;
    const { previewFinished } = this.props.state.editorUI;

    const referer = getDomain();
    if (folderId !== prevFolderId) {
      this.folderId = folderId;
      const legacyFolder = configExist('legacyFolder', referer);
      this.ORDER_NOW_URL = `${legacyFolder}&id=${this.folderId}`;
    }


    // After save actions
    if (this.continue && previewFinished === 'finished') {
      // Set product status after save current state
      fetch(this.ORDER_URL, {
        method: 'GET',
        cors: 'no-cors',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        credentials: 'include',
      })
        .then(response => response.json())
        .then((json) => {
          if (json.error) {
            console.log('error', json);
          } else {
            window.location.href = this.ORDER_NOW_URL;
          }
        })
        .catch((resp) => {
          console.error(resp);
        });
    } else if (previewFinished === 'finished') {
      window.location.href = this.ORDER_NOW_URL;
    }
  }


  preloader = () => <svg width="15" className="savePreloader" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g fill="none" fillRule="evenodd"><g transform="translate(1 1)" strokeWidth="2"><circle strokeOpacity=".5" cx="18" cy="18" r="18" /><path d="M36 18c0-9.94-8.06-18-18-18" /></g></g></svg>

  clockIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path id="kesobb_folytatom" d="M7.25-10.25A.748.748,0,0,1,8-11a.748.748,0,0,1,.75.75V-6.4l2.666,1.775A.724.724,0,0,1,11.6-3.584a.688.688,0,0,1-1.012.181l-3-2a.685.685,0,0,1-.334-.625ZM8-14a8,8,0,0,1,8,8A8,8,0,0,1,8,2,8,8,0,0,1,0-6,8,8,0,0,1,8-14ZM1.5-6A6.5,6.5,0,0,0,8,.5,6.5,6.5,0,0,0,14.5-6,6.5,6.5,0,0,0,8-12.5,6.5,6.5,0,0,0,1.5-6Z" transform="translate(0 14)" fill="#fff"/></svg>
  cartIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="17.93" height="16" viewBox="0 0 17.93 16"><path id="befejezes" d="M0-13.25A.75.75,0,0,1,.75-14H3a.752.752,0,0,1,.738.61l.047.39H9.75v3.191L9-10.531a.722.722,0,0,0-1.034,0,.722.722,0,0,0,0,1.034l2,2A.679.679,0,0,0,11-7.5l2-2a.679.679,0,0,0,0-1.034.722.722,0,0,0-1.034,0l-.719.722V-13h5.681a1.014,1.014,0,0,1,.962,1.271l-1.687,6A1,1,0,0,1,15.244-5H5.334l.287,1.5H15.25a.748.748,0,0,1,.75.75.748.748,0,0,1-.75.75H4.972a.746.746,0,0,1-.709-.609L2.379-12.5H.75A.75.75,0,0,1,0-13.25ZM7,.5A1.5,1.5,0,1,1,5.5-1,1.5,1.5,0,0,1,7,.5Zm6,0A1.5,1.5,0,1,1,14.5,2,1.5,1.5,0,0,1,13,.5Z" transform="translate(0 14)" fill="#fff"/></svg>
  
  orderNow() {
    const { lang, state } = this.props;
    const placeholderById = state.entities.placeholders.byId;

    if (hasEmptyPlaceholderInPages(placeholderById, lang)) {
      showAlertModal(lang.title_notice, lang.edit_calendar_before_order);
      return;
    }

    this.continue = true;
    this.order = true;
    this.saveState();

    return true;
  }

  continueLater = () => {
    const { lang, state } = this.props;

    const currentPage = GetActivePage(state.entities.pages.byId);
    const placeholderById = state.entities.placeholders.byId;
    if (hasEmptyPlaceholder(currentPage, placeholderById, lang)) {
      return;
    }
    this.continue = false;
    this.saveState();
  }

  saveState() {
    const bookId = getParams('calendarId');
    const referer = getDomain();

    const clearPreviewUrl = configExist('clearThumbnailURL', referer);
    const clearUrl = `${clearPreviewUrl}/${bookId}`;

    fetch(clearUrl, {
      cors: 'no-cors',
      credentials: 'include',
    }).then(result => result.json())
      .then(() => {
        this.props.dispatch(isOrder(true));
        this.props.dispatch(setIsActive(10));
        this.props.dispatch(saveState(false));
      });
  }

  render() {
    const {
      lang,
      hideComponent,
      bookId,
    } = this.props;
    const { isLoading } = this.props.state.entities.io.fetchState;

    const demoBookId = 0;
    if (bookId === demoBookId) {
      return false;
    }

    return (
      <div>
        { hideComponent ? '' :
        <button className="btn green-btn save-state" onClick={this.continueLater}>
          { isLoading && !this.order ? this.preloader() : this.clockIcon() }
          { lang.top_menu_continue_later }
        </button>
        }

        <button className="btn green-btn save-state" onClick={this.orderNow}>
          { isLoading && this.order ? this.preloader() : this.cartIcon() }
          { lang.top_menu_order }
        </button>


      </div>
    );
  }
}

SaveState.defaultProps = {
  lang: {},
  folderId: 0,
  state: {},
  isLoading: false,
  bookId: 1,
  hideComponent: false,
  dispatch: () => {},
};

SaveState.propTypes = {
  lang: PropTypes.object,
  folderId: PropTypes.number,
  state: PropTypes.object,
  isLoading: PropTypes.bool,
  bookId: PropTypes.number,
  hideComponent: PropTypes.bool,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  state,
}))(SaveState);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/save-state/saveState.jsx